module.exports = __webpack_public_path__ + "static/media/CheckmarkSalesWhtie.165dc8e9.svg";